// extracted by mini-css-extract-plugin
module.exports = {"form__submitted":"form-content_form__submitted__O2IfI","form__wrapper":"form-content_form__wrapper__2kNeh","formContainer":"form-content_formContainer__zJbSS"};